import JoinUs from "@/components/pages/about/join-us";
import Banner from "@/components/pages/team/banner";
import Card from "@/components/pages/team/card";
import Collage from "@/components/pages/team/collage";
import React from "react";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { getUrqlClient } from "@/lib/urql-client";
import { sanitize } from "@/framework/utils/sanitize";
import Seo from "@/utils/seo";
export default function Culture({ members }) {
  const seo = {
    slug: "culture",
    metaTitle: "Creative Work Culture at Chalk Studio | Design Team",
    metaDescription:
      "Step into the creative culture of Chalk Studio. See how collaboration, innovation, and passion shape our interior design process.",
  };
  return (
    <>
      <Seo seo={seo} />
      <Banner />
      <Collage members={members} />
      <Card />
      <JoinUs teamButton={false} />
    </>
  );
}
export async function getStaticProps({ params }) {
  const client = await getUrqlClient();
  let members = null;
  try {
    members = await client.query(QUERY_ENDPOINTS.QUERY_TEAM_MEMBERS, {
      requestPolicy: "network-only",
    });
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      members:
        members?.data?.teamPage?.data?.attributes?.team_members?.data?.map(
          (row) => sanitize(row)
        ) ?? {},
    },
    revalidate: 1, // In seconds
  };
}
